





















































































































































































import Vue from 'vue';
import moment from 'moment-timezone';
import _ from 'lodash';

import { SimNao, SimNaoNaoSei } from '../../../../back/src/types';
import { simNaoItens, simNaoNaoSeiItens } from '../../utils/constants';

export default Vue.extend({
  name: 'ThePacientesCadastroExternoEtapa4',
  props: {
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      valid: false,
      menuDataUltimaMenstruacao: false,
      menuDataProvavelParto: false,
      form: {
        planoSaude: null,
        nomePlanoSaude: '',
        tipoPlanoSaude: '',
        fimCarenciaParto: null,
        gestacao: null,
        dataUltimaMenstruacao: '',
        dataProvavelParto: '',
        condicoesEspeciaisItems: [
          { label: 'Hipertensão crônica', checked: false },
          { label: 'Hipertensão na gestação', checked: false },
          { label: 'Diabetes tipo 1 ou 2', checked: false },
          { label: 'Diabetes gestacional já diagnosticada nesta gestação', checked: false },
          { label: 'Está grávida de gêmeos', checked: false },
          { label: 'Hipotireoidismo', checked: false },
          { label: 'Uso de anti-coagulante por trombofilia', checked: false },
          { label: 'Transtorno de ansiedade ou depressão ou bipolaridade', checked: false },
          { label: 'Faz uso de medicamentos diários (não vitaminas)', checked: false },
        ],
        condicoesEspeciaisOutras: '',
        condicoesEspeciais: '',
      },
      rules: {
        required: [
          (v: string) => !!v || 'Campo obrigatório',
        ],
      },
      items: {
        planoSaude: simNaoItens,
        fimCarenciaParto: simNaoNaoSeiItens,
        gestacao: simNaoItens,
      },
      SimNao,
      SimNaoNaoSei,
    };
  },
  computed: {
    formEtapa4(): Vue & { validate: () => boolean, resetValidation: () => boolean } {
      return this.$refs.formEtapa4 as Vue & {
        validate: () => boolean,
        resetValidation: () => boolean
      };
    },
    dataUltimaMenstruacaoFormatada(): string {
      if (this.form.dataUltimaMenstruacao) {
        const momentDataUltimaMenstruacao = moment(this.form.dataUltimaMenstruacao);
        if (momentDataUltimaMenstruacao.isValid()) {
          return momentDataUltimaMenstruacao.format('DD/MM/YYYY');
        }
      }
      return '';
    },
    dataProvavelPartoFormatada(): string {
      if (this.form.dataProvavelParto) {
        const momentDataProvavelParto = moment(this.form.dataProvavelParto);
        if (momentDataProvavelParto.isValid()) {
          return momentDataProvavelParto.format('DD/MM/YYYY');
        }
      }
      return '';
    },
  },
  mounted() {
    const formStore = this.$store.getters.pacienteFormExternoEtapa4;
    if (!_.isEmpty(formStore)) {
      this.form = formStore;
    }
    this.formEtapa4.resetValidation();
  },
  methods: {
    voltar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa4', this.form);
      this.$emit('voltar');
    },
    continuar() {
      this.$store.dispatch('updatePacienteFormExternoEtapa4', this.form);
      if (!this.formEtapa4.validate()) {
        return;
      }
      // forma texto condicoes especiais
      let condicoesEspeciais = '';
      _.forEach(this.form.condicoesEspeciaisItems, (el) => {
        if (el.checked) {
          condicoesEspeciais = `${condicoesEspeciais}${el.label}\n`;
        }
      });
      if (this.form.condicoesEspeciaisOutras !== '') {
        condicoesEspeciais = `${condicoesEspeciais}Outras: ${this.form.condicoesEspeciaisOutras}`;
      }
      this.form.condicoesEspeciais = condicoesEspeciais;
      // envia para o parent
      this.$emit('etapaValida', this.form);
    },
  },
});
